<template>
  <!-- <div class="wrapper">
    <p class="title">
      {{ getModalInfo.is_active == 0 ? "Activate User" : "Archive User" }}
    </p>
    <div class="content">
      <p class="confirmation-title" v-if="getModalInfo.is_active == 0">
        Are you sure you want to <b>Activate</b> {{ getModalInfo.fullName }} ?
      </p>
      <div class="deactive-wrapper" v-else>
        <p class="confirmation-title deactive">
          Are you sure you want to <b>"Archive"</b> {{ getModalInfo.fullName }}  ?
        </p>
        <p class="info">
          By archiving this user, he will no longer be able to check 
          in at any of your sites nor access the company </p>
          <p class="info"> dashboard (if he is permitted to do so).
        </p>
        <b-spinner v-if="isLoading" variant="secondary" role="status" size="sm" class="wizard-spinner"/>
        <br v-if="siteName && areaName"/>
        <p v-if="siteName && areaName" class="info archive-hint-message">This user is signed into "{{ siteName }} - {{ areaName }}", he will be auto signed out.</p>

      </div>
    </div>
    <hr class="h-line" />
    <div class="action-btns" :class="getModalInfo.is_active == 1 && 'reverse'">
      <button class="submit-btn btn" :class="getModalInfo.is_active == 0 ? 'btn-primary' : 'btn-outline-danger'"
      size="md" @click="onSubmit" :disabled="getLoading || isLoading" >
      <i v-if="getLoading" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"></i>
      <span v-else>{{ getModalInfo.is_active == 0 ? "Activate" : "Archive" }}</span>
    </button>
    <button class="btn cancel-btn" :class="getModalInfo.is_active == 0 ? 'btn-outline-danger' : 'btn-primary'"
      @click="$bvModal.hide('userStatusToggleConfirmModal')">Cancel    
    </button>

    
      
    </div>
  </div> -->
  <VpConfirmModal :modalId="'userStatusToggleConfirmModal'" :isLoading="isLoading">
    <template v-slot:title>
      <span>{{  getModalInfo.is_active == 0 ? `${$t('users.form.activate')} ${$t('common.user')}` : `${$t('users.form.archive')} ${$t('common.user')}` }}</span>
    </template>

    <template v-slot:text1>
      <span>{{ $t('common.notes.areYouSureYouWant') }} <strong>{{ getModalInfo.is_active == 0 ? `"${$t('users.form.activate')}"` : `"${$t('users.form.archive')}"` }}</strong> {{ getModalInfo.fullName }}</span>
    </template>

    <template v-slot:text2>
      <span v-if="getModalInfo.is_active == 1">{{ $t('users.form.archiveHint') }}</span>
    </template>

    <template v-slot:text3>
      <span v-if="siteName && areaName">{{ $t('users.form.signInto') }} "{{ siteName }} - {{ areaName }}"{{ $t('users.form.willBeSignedOut') }}</span>
    </template>

    <template v-slot:buttons>
      <VpButton :text="getModalInfo.is_active == 0 ? $t('users.form.activate') : $t('users.form.archive')" :disabled="getLoading || isLoading" :isDanger="getModalInfo.is_active == 1" @click="onSubmit" />
      <VpButton :text="$t('common.cancel')" :isDanger="getModalInfo.is_active == 0" @click="$bvModal.hide('userStatusToggleConfirmModal')" />
    </template>
  </VpConfirmModal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
        return { 
          siteName : null,
          areaName : null,
          isLoading : true,
        };
    },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("userStatusToggleConfirmModal");
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("users", ["getLoading", "getModalState"]),
  },
  methods: {
    ...mapActions("users", ["resetLoading", "denyUser", "fetchLastVisitForUser"]),

    async onSubmit() {
      await this.denyUser([
        {
          user_id: this.getModalInfo.id,
          active: this.getModalInfo.is_active == 0 ? 1 : 0,
        },
      ]);
      this.$emit('changeUserStatusOrDeleted', this.getModalInfo.id);
    },
  },
  beforeMount() {
    console.log('this.getModalInfooooo', this.getModalInfo);
    this.fetchLastVisitForUser({
      params:{
        user_id : this.getModalInfo.id,
        entity_id : this.getModalInfo.current_entity.entity_id
      }
    }).then((data)=>{
      // console.log('data', data);
      this.isLoading = false;
      this.siteName = data && data.data  ? data.data.site_name : null ;
      this.areaName = data && data.data  ? data.data.area_name : null ;

    });
    this.resetLoading();

  },
};
</script>
